var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRssIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32.609,
    viewBox: "0 0 31 32.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40949",
    "data-name": "Group 40949",
    transform: "translate(-851 -193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_48183",
    "data-name": "Path 48183",
    transform: "translate(855.913 193)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.4782543182373 31.85868453979492 L 2.608695268630981 31.85868453979492 C 1.583805203437805 31.85868453979492 0.7500051259994507 31.02488327026367 0.7500051259994507 29.9999942779541 L 0.7500051259994507 2.608694076538086 C 0.7500051259994507 1.583804130554199 1.583805203437805 0.7500041723251343 2.608695268630981 0.7500041723251343 L 16.94751167297363 0.7500041723251343 L 25.33695602416992 8.17221736907959 L 25.33695602416992 29.9999942779541 C 25.33695602416992 31.02488327026367 24.50314521789551 31.85868453979492 23.4782543182373 31.85868453979492 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.608695983886719 1.500003814697266 C 1.997354507446289 1.500003814697266 1.499994277954102 1.997364044189453 1.499994277954102 2.608694076538086 L 1.499994277954102 29.9999942779541 C 1.499994277954102 30.61132431030273 1.997354507446289 31.10868453979492 2.608695983886719 31.10868453979492 L 23.4782543182373 31.10868453979492 C 24.08958435058594 31.10868453979492 24.58694458007812 30.61132431030273 24.58694458007812 29.9999942779541 L 24.58694458007812 8.51007080078125 L 16.66336631774902 1.500003814697266 L 2.608695983886719 1.500003814697266 M 2.608695983886719 3.814697265625e-06 L 17.23165512084961 3.814697265625e-06 L 26.08694458007812 7.83436393737793 L 26.08694458007812 29.9999942779541 C 26.08694458007812 31.44073486328125 24.91899490356445 32.60868453979492 23.4782543182373 32.60868453979492 L 2.608695983886719 32.60868453979492 C 1.16795539855957 32.60868453979492 -5.7220458984375e-06 31.44073486328125 -5.7220458984375e-06 29.9999942779541 L -5.7220458984375e-06 2.608694076538086 C -5.7220458984375e-06 1.167953491210938 1.16795539855957 3.814697265625e-06 2.608695983886719 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#9facc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10859",
    "data-name": "Rectangle 10859",
    transform: "translate(852 204.538)",
    fill: "#e18317",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.962,
    height: 13.702,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 26.962,
    height: 14.702,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_48182",
    "data-name": "Path 48182",
    transform: "translate(872.452 192.36)",
    fill: "#9facc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.747350692749023 9.217711448669434 L 2.854639530181885 9.217711448669434 C 1.556289553642273 9.217711448669434 0.4999995529651642 8.161421775817871 0.4999995529651642 6.863061904907227 L 0.4999995529651642 1.709301948547363 C 1.367621302604675 2.438008546829224 2.810538768768311 3.660752534866333 4.263639450073242 4.939941883087158 C 7.11998462677002 7.454435348510742 8.278881072998047 8.653020858764648 8.747350692749023 9.217711448669434 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.604681015014648 8.717711448669434 C 6.915859222412109 8.017214775085449 5.75441837310791 6.914700031280518 3.797339677810669 5.195721626281738 C 2.78804874420166 4.309226036071777 1.791762351989746 3.456317186355591 0.9999995827674866 2.785326957702637 L 0.9999995827674866 6.863061904907227 C 0.9999995827674866 7.885721683502197 1.831989526748657 8.717711448669434 2.854639530181885 8.717711448669434 L 7.604681015014648 8.717711448669434 M 9.392589569091797 9.717711448669434 L 2.854639530181885 9.717711448669434 C 1.278069615364075 9.717711448669434 -4.368591248748999e-07 8.439641952514648 -4.368591248748999e-07 6.863061904907227 L -4.368591248748999e-07 0.6401417255401611 C -4.368591248748999e-07 0.6401417255401611 10.96915912628174 9.717711448669434 9.392589569091797 9.717711448669434 Z",
    stroke: "none",
    fill: "#9facc2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RSS",
    transform: "translate(855.144 214.981)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RSS")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssIcon);
export default __webpack_public_path__ + "static/media/rss-icon.edbda72295a17ef10d43f28185edf878.svg";
export { ForwardRef as ReactComponent };